<template>
  <ul class="seat-status-tips">
    <li v-for="(s, index) in seatStatusList" class="item" :key="index">
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="s.icon" />
      </svg>
      <span class="label">{{s.text}}</span>
    </li>
  </ul>
</template>

<script>
import '../../../../stylesheet/iconfont/seatlock'

export default {
  name: 'SeatStatusTips',
  data() {
    return {
      seatStatusList: [
        {
          text: '不可选',
          icon: '#icon-icon_lock1',
        },
        {
          text: '已售',
          icon: '#icon-zuowei-danren-yishou',
        },
        {
          text: '可选',
          icon: '#icon-1-11',
        },
        {
          text: '选中',
          icon: '#icon-1-141',
        },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
.seat-status-tips {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding-bottom: 135px;
  padding-top: 10px;
  background-color: #f4f4f4;
  z-index: 2;

  .item {
    display: inline-flex;
    align-items: center;
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }

  .icon {
    width: 22px;
    height: 20px;
    font-size: 20px;
    margin-right: 5px;
  }

  .label {
    font-size: 13px;
    color: #797d82;
  }
}
</style>



